import React from 'react';
import './MainPage.css';

const MainPage: React.FC = () => {
  return (
    <div className="main-page">
      <div className="page-header">
        <h1>Dashboard</h1>
        <p>Welcome to your A-Casa dashboard</p>
      </div>
      
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3>Total Logs</h3>
            <p className="stat-number">1,234</p>
            <p className="stat-change positive">+12% from last month</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">🔍</div>
          <div className="stat-content">
            <h3>Active Sessions</h3>
            <p className="stat-number">56</p>
            <p className="stat-change positive">+8% from last week</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">⚡</div>
          <div className="stat-content">
            <h3>System Status</h3>
            <p className="stat-number">Online</p>
            <p className="stat-change positive">All systems operational</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">🛡️</div>
          <div className="stat-content">
            <h3>Security Score</h3>
            <p className="stat-number">98%</p>
            <p className="stat-change positive">Excellent security</p>
          </div>
        </div>
      </div>
      
      <div className="recent-activity">
        <h2>Recent Activity</h2>
        <div className="activity-list">
          <div className="activity-item">
            <div className="activity-icon">📝</div>
            <div className="activity-content">
              <h4>New log entry created</h4>
              <p>System generated a new log entry at 2:30 PM</p>
              <span className="activity-time">2 minutes ago</span>
            </div>
          </div>
          
          <div className="activity-item">
            <div className="activity-icon">👤</div>
            <div className="activity-content">
              <h4>User login</h4>
              <p>User john.doe logged in successfully</p>
              <span className="activity-time">15 minutes ago</span>
            </div>
          </div>
          
          <div className="activity-item">
            <div className="activity-icon">🔧</div>
            <div className="activity-content">
              <h4>System maintenance</h4>
              <p>Scheduled maintenance completed successfully</p>
              <span className="activity-time">1 hour ago</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage; 